import { store } from "@/store";
import * as ENV from "@/config.js";

let getFacility = ENV.VUE_APP_FACILITY;

export const getBookingVenueSettings = () => {
    return store?.state[`${getFacility}_booking`]?.venueSettings || store?.state.tennis_booking?.venueSettings;
};

export const getBundleBookingVenueSettings = () => {
    return store?.state[`${getFacility}_booking`]?.bundleVenueSettings || store?.state.tennis_booking?.bundleVenueSettings || [];
};

export const getTemporarybookingDetails = () => {
    return store?.state[`${getFacility}_booking`]?.temporarybookingdetails || store?.state.tennis_booking?.temporarybookingdetails;
};

export const getMultibookingDetails = () => {
    return store?.state[`${getFacility}_booking`]?.multibookingdetails || store?.state.tennis_booking?.multibookingdetails;
};

export const getBookingVenueTypeSettings = () => {
    return store?.state[`${getFacility}_booking`]?.venuetypesetting || store?.state.tennis_booking?.venuetypesetting;
};

export const getBookingDetailSettings = () => {
    return store?.state[`${getFacility}_booking`]?.bookingDetailSettings || store?.state.tennis_booking?.bookingDetailSettings;
};

export const getBookingSearchSettings = () => {
    return store?.state[`${getFacility}_booking`]?.bookingSearchSettings || store?.state.tennis_booking?.bookingSearchSettings;
};

export const getBookingGeneral = () => {
    return store?.state[`${getFacility}_booking`]?.bookingGeneral || store?.state.tennis_booking?.bookingGeneral;
};

export const getbookedVenues = () => {
    return store?.state[`${getFacility}_booking`]?.bookedVenues || store?.state.tennis_booking?.bookedVenues;
};

export const getselectedSearchedVenue = () => {
    return store?.state[`${getFacility}_booking`]?.selectedSearchedVenue || store?.state.tennis_booking?.selectedSearchedVenue;
};

export const getVenueOptions = () => {
    return store?.state[`${getFacility}_booking`]?.venueOptions || store?.state.tennis_booking?.venueOptions || [];
};

// Fetching data from admin store

export const getAdminGeneralSettings = () => {
    return store?.state[`${getFacility}_admin`]?.generalSettings[0] || store?.state.tennis_admin?.generalSettings[0];
};

export const getAdminSearchSettings = () => {
    return store?.state[`${getFacility}_admin`]?.searchSettings || store?.state.tennis_admin?.searchSettings;
};

export const getAdminDetailSettings = () => {
    return store?.state[`${getFacility}_admin`]?.detailSettings || store?.state.tennis_admin?.detailSettings;
};

export const getAdminVenueSettings = () => {
    return store?.state[`${getFacility}_admin`]?.venueSettings || store?.state.tennis_admin?.venueSettings;
};

export const getAdminVenueTypeSettings = () => {
    return store?.state[`${getFacility}_admin`]?.venuetypesetting || store?.state.tennis_admin?.venuetypesetting;
};

export const getAdminFaciltySettings = () => {
    return store?.state[`${getFacility}_admin`]?.facilitySettings || store?.state.tennis_admin?.facilitySettings;
};
